import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import * as React from 'react';
import { AssetScreen } from 'screens/AssetScreen/AssetScreen';
import { AssetsScreen } from 'screens/AssetsScreen/AssetsScreen';

const Stack = createNativeStackNavigator<NavigationStacks[Stacks.OFFLINE]>();

type Props = {
  inPages?: boolean;
};

export const TabOfflineScreen: React.FC<Props> = ({ inPages }) => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        contentStyle: {
          backgroundColor: 'transparent',
        },
      }}
      initialRouteName={Screens.OFFLINE_ASSETS}
    >
      <Stack.Screen
        name={Screens.OFFLINE_ASSETS}
        component={AssetsScreen}
        initialParams={{ inPages: !!inPages }}
      />
      <Stack.Screen name={Screens.OFFLINE_ASSET} component={AssetScreen} />
    </Stack.Navigator>
  );
};
